<template>
  <div id="top">
    <div class="top-time">
      <div class="top-time-body">
        <div class="top-timeBody-value">
          {{year}}
        </div>
      </div>
      <div class="top-time-body">
        <div class="top-timeBody-value">
          {{minute}}
        </div>
      </div>
    </div>

<!--    <div class="top-title">-->
<!--      <div class="top-title-body">-->
<!--        <div class="top-titleBody-value">-->
<!--          农&emsp;&emsp;业&emsp;&emsp;四&emsp;&emsp;情&emsp;&emsp;监&emsp;&emsp;测&emsp;&emsp;平&emsp;&emsp;台-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="top-title">
<!--      <dv-decoration-5 style="width:100%;height:60px; margin-top: 30px"/>-->
<!--      <div style=" position: absolute; font-size: 30px; font-family: SimSun;  font-weight: bold;left: 50%; top: 15px; transform: translateX(-50%); color: #ffffff;"> 农&emsp;业&emsp;四&emsp;情&emsp;监&emsp;测&emsp;平&emsp;台</div>-->

      <dv-decoration-7 class="top-title-body">
        &emsp;农&emsp;业&emsp;四&emsp;情&emsp;监&emsp;测&emsp;平&emsp;台&emsp;
      </dv-decoration-7>

    </div>
    <div class="top-logout">
      <div class="top-logout-name">
        {{email}}
      </div>

      <div class="top-logout-value">
<!--        <img src="../img/back.png">-->
        <el-dropdown>
          <img src="../img/back.png">
          <el-dropdown-menu slot="dropdown">
            <p @click="updatePwd()"><el-dropdown-item>修改密码</el-dropdown-item></p>
            <p @click="logout()"><el-dropdown-item>退出</el-dropdown-item></p>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import router from '../../router'
  export default {
    name: 'Top',
    data() {
      return {
        year: '2023-02-10',
        minute: '14:00',
        time: null,
        email:''
      }
    },

    mounted() {
      this.getNowTime();
      // this.email = localStorage.getItem('email');
      this.email = this.$commonFun.unCompileStr(localStorage.getItem('email'));
    },

    beforeDestroy() {
      clearInterval(this.time);
      this.time = null;
    },

    methods: {
      getNowTime() {
        this.year = moment().format("YYYY-MM-DD");
        this.minute = moment().format("HH:mm:ss");
        this.time = window.setInterval(() => {
          setTimeout(() => {
            this.year =  moment().format("YYYY-MM-DD");
            this.minute =  moment().format("HH:mm:ss");
          },0)
        },1000);
      },

      updatePwd() {
        this.$popup({
          click: () => {
            // 点击按钮事件
            //   this.$router.push('……')
            console.log(`点击按钮了！`)
          },
        })
      },

      logout() {
        localStorage.clear();
        router.replace('/');
      }
    }
  }
</script>

<style lang="less">
  @import "../less/Top";
</style>



// WEBPACK FOOTER //
// src/components/view/Top.vue